<template>
  <b-card>
    <h3>ETA</h3>
    <table>
      <tbody>
        <tr
          v-for="(el, idx) in tripDetailsEta"
          :key="idx"
        >
          <td> {{ el.name }} </td>
          <td
            class="d-flex justify-content-end"
            :class="{'text-success': el.colored}"
          >
            {{ el.value }}
          </td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
import { inject, computed } from '@vue/composition-api'
import { BCard } from 'bootstrap-vue'

export default {
  components: { BCard },
  setup() {
    const trip = inject('trip')
    const tripDetailsEta = computed(() => {
      let arr = []
      if (trip.value) {
        const { metadata } = trip.value
        const {
          eta, promo,
        } = metadata
        const estimateTimeSlicesArr = eta?.price?.fare?.details?.time_slicings?.slices
        arr = [
          { value: estimateTimeSlicesArr && estimateTimeSlicesArr.length ? `${(estimateTimeSlicesArr[estimateTimeSlicesArr.length - 1].to_unit).toFixed(3)} Minutes` : '_', name: 'Estimate Time' },
          { value: eta?.totalDistance ? `${eta?.totalDistance} KM` : '_', name: 'Estimate Distance ' },
          { value: eta?.price?.fare?.total ? `${eta?.price?.fare?.total.toFixed(2)} $` : '_', name: 'Subtotal estimated price', colored: true },
          { value: eta?.zone ? eta?.zone?.split('::')[1] : '_', name: 'Pick Up Zone' },
          { value: promo?.coupon ? promo?.coupon : '_', name: 'Applied Promo Code ' },
          { value: eta?.price?.fare?.total && eta?.totalAfterPromo ? `${(eta?.price?.fare?.total?.toFixed(2) - eta?.totalAfterPromo.toFixed(2)).toFixed(2)}$` : '_', name: 'Promo code price', colored: true },
          { value: eta?.totalAfterPromo ? `${eta?.totalAfterPromo?.toFixed(2)}$` : '_', name: 'Total estimated price ', colored: true },
        ]
      }
      return arr
    })
    return {
      tripDetailsEta,
    }
  },

}
</script>

<style src="./table-style.css" scoped>

</style>
